import { exportTemplatesFactory } from '@eas/common-web';
import { ExportTags } from '@enums';

export const ExportTemplates = exportTemplatesFactory({
  exportTag: ExportTags.EXPORT_TEMPLATES,
});
